import { useCallback, useEffect, useState } from 'react';

import { isTouchDevice } from '@repo/detection';

import type { UsePopoverOpenFunction } from './types';

export const usePopoverOpen: UsePopoverOpenFunction = (props) => {
  const isTouch = isTouchDevice();
  const { openOnHover } = props;
  const canOpenOnHover = openOnHover && !isTouch;

  const [open, setOpen] = useState(props.open);
  const [newOpenState, setNewOpenState] = useState<boolean | null>(null);

  const onPointerEnter = useCallback(() => {
    setNewOpenState(true);
  }, []);
  const onPointerLeave = useCallback(() => {
    setNewOpenState(false);
  }, []);

  useEffect(() => {
    if (!canOpenOnHover || newOpenState === null) {
      return;
    }
    let timeoutId: ReturnType<typeof setTimeout>;

    if (newOpenState) {
      timeoutId = setTimeout(() => {
        setOpen(true);
        setNewOpenState(null);
      }, props.openDelay);
    } else {
      timeoutId = setTimeout(() => {
        setOpen(false);
        setNewOpenState(null);
      }, props.closeDelay);
    }

    return () => clearTimeout(timeoutId);
  }, [open, canOpenOnHover, newOpenState, props.openDelay, props.closeDelay]);

  return {
    open: canOpenOnHover ? (props.open === false ? false : open) : props.open, // if open is explicitly set to false, then it should have higher priority
    onPointerEnter: canOpenOnHover ? onPointerEnter : undefined,
    onPointerLeave: canOpenOnHover ? onPointerLeave : undefined,
    onOpenChange: props.onOpenChange,
  };
};
